import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { IService } from '../asp/interfaces';
import { ChannelsComponent } from './channels.component';

@Injectable({
  providedIn: 'root'
})

export class ChannelService implements IService {
  private dialogRef: MatDialogRef<any>;

  constructor(private dialog: MatDialog) {
  }
 
   
  showWindow() {
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let errorComp = this.dialogRef.componentInstance as ChannelsComponent;
      errorComp.dialogRaise();
    }
    else {
      this.dialogRef = this.dialog.open(ChannelsComponent, ChannelsComponent.createDialogConfig());
      let errorComp = this.dialogRef.componentInstance as ChannelsComponent;
      errorComp.dialogRaise();
    }
  }
}
